import React, {Component} from "react"
import PropTypes from "prop-types"
import {get, isEqual} from "lodash"

import {Hidden} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"

import {PROPERTY as NOTIFICATION_USERS_PROPERTY} from "./NotificationUsers"


export const PROPERTY = "preferences.emails.notificationUserIds"


export const schema = (required = false) => Validation.array(required ? "This field is required" : null)


class NotificationUserIds extends Component {
  constructor(props) {
    super(props)
    this.users = get(props.schedule, NOTIFICATION_USERS_PROPERTY)
  }

  /** Listen for any props changes */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const nextUsers = get(nextProps.schedule, NOTIFICATION_USERS_PROPERTY)

    this.setUserIdsFromUsers(nextUsers)
  }

  /** Do the logic check to determine whether emitting a change is needed */
  setUserIdsFromUsers(nextUsers) {
    if (!isEqual(nextUsers, this.users)) {
      this.users = nextUsers
      this.handleChange(nextUsers.map((u) => u.id))
    }
  }

  /** Dispatch value changes for the property */
  handleChange = (value) => {
    this.props.onChange(this.props.schedule, PROPERTY, value)
  }

  /** Using a hidden text field to enforce validation */
  render() {
    const idNamespace = id("NotificationUserIds", this.props)
    const {schedule, required, name} = this.props

    return (
      <Hidden
        id={idNamespace}
        name={name}
        value={get(schedule, name)}
        validation={schema(required)} />
    )
  }
}

NotificationUserIds.propTypes = {
  schedule: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  name: PropTypes.string
}

NotificationUserIds.defaultProps = {
  required: false,
  name: PROPERTY
}

export default NotificationUserIds
